<template>
  <header>
    <div class="logo_bar">
      <div class="logo">
        <img
          :src="webContents.images.logo"
          :srcset="`${webContents.images.logo} 1x, ${webContents.images.logo2x} 2x`"
          alt="eemo"
        />
      </div>
    </div>
    <div class="page_navi">
      <div class="container">
        <h1 class="page_name">
          <span>{{ title }}</span>
        </h1>
      </div>
    </div>
  </header>
</template>

<script>
import queryString from "query-string";
import Config from "@/conf/Config";

export default {
  props: ["hasError", "corpParam"],
  computed: {
    screenId: () => "HEADER",
    webContents() {
      let ret = { article: "", images: "" };
      if (this.corpParam && this.corpParam.memberRegistrationWebContents) {
        ret = JSON.parse(this.corpParam.memberRegistrationWebContents)[this.screenId];
      }
      return ret;
    },
    title() {
      if (this.hasError) {
        document.title = `${Config.ERROR_TITLE} | ${this.corpParam.serviceName}`;
        return Config.ERROR_TITLE;
      }
      if (queryString.parse(window.location.search).complete === undefined) {
        document.title = `${Config.INDEX_TITLE} | ${this.corpParam.serviceName}`;
        return Config.INDEX_TITLE;
      }
      document.title = `${Config.COMPLETE_TITLE} | ${this.corpParam.serviceName}`;
      return Config.COMPLETE_TITLE;
    },
  },
};
</script>
